import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp'
import { TopNavUserComponent } from '@modules/navigation/components'
import { SideNavItem, SideNavItems, SideNavSection } from '@modules/navigation/models'
import { NavigationService } from '@modules/navigation/services'
import moment from 'moment'
import { Subscription } from 'rxjs'

@Component({
    selector: 'sb-side-nav',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './side-nav.component.html',
    styleUrls: ['side-nav.component.scss'],
    providers: [TopNavUserComponent],
    standalone: false
})
export class SideNavComponent implements OnInit, OnDestroy {
  @Input() sidenavStyle!: string
  @Input() sideNavItems!: SideNavItems
  @Input() sideNavSections!: SideNavSection[]

  subscription: Subscription = new Subscription()

  navItemContactUs: SideNavItem = {
    sideItemMenuHidden: false,
    text: 'Fale conosco',
    externalLink: true,
    iconAwesome: true,
    new: moment('2021-10-30', 'yyyy-MM-dd'),
    icon: faWhatsapp,
    target: '_blank',
    disable: true
  }

  constructor(
    private topNavUserComponent: TopNavUserComponent,
    public navigationService: NavigationService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  logout(template: any) {
    this.navigationService.toggleSideNav()
    this.topNavUserComponent.logout(template)
  }
}
